// extracted by mini-css-extract-plugin
module.exports = {"submitRoot":"OtpSlide_submitRoot__mQSUq","loginSubmitRoot":"OtpSlide_loginSubmitRoot__eyH9V","root":"OtpSlide_root__3dcsW"};